const onGetCurrentPath = (path: string): string => {
  const splitPath = path.trim().split('/');
  if (splitPath.length > 1) {
    return splitPath.slice(0, -1).join('/');
  }
  return splitPath.length > 1 ? splitPath.join('/') : '';
};

export default onGetCurrentPath;
